import styled from "styled-components";
import { color } from "../../../shared/styles";

export const HeaderWrapper = styled.div`
    width: 100%;
    min-height: 40px;
    height: auto;
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    margin-bottom: 4px;
`;

export const HeaderLeft = styled.div`
    display: flex;
    flex-direction: column;
    gap: 6px;
`;

export const HeaderRight = styled.div`
    display: flex;
    align-items: center;
    gap: 8px;
`;

export const TitleRow = styled.div`
    display: flex;
    align-items: center;
    gap: 8px;
`;

export const MetaRow = styled.div`
    display: flex;
    align-items: center;
    gap: 8px;
    flex-wrap: wrap;
`;

export const MetaBar = styled.div`
    display: inline-flex;
    align-items: center;
    gap: 12px;
    padding: 6px 8px;
    border-radius: 6px;
    border: 1px solid ${color.secondary.BORDER};
    background: ${color.emphasis.NEUTRAL_N5};
    transition: background-color 0.15s ease, border-color 0.15s ease, box-shadow 0.15s ease, transform 0.15s ease;
    will-change: transform, box-shadow;

    &:hover {
        background: ${color.emphasis.NEUTRAL_N0};
        border-color: ${color.secondary.GREY_4};
        box-shadow: 0 2px 10px rgba(16, 47, 67, 0.12);
        transform: translateY(-2px);
    }

    &:active {
        transform: translateY(-1px);
        box-shadow: 0 1px 6px rgba(16, 47, 67, 0.12);
    }

    &:focus-within {
        outline: none;
        border-color: ${color.primary.BLUE_B100};
        box-shadow: 0 0 0 2px rgba(0, 88, 160, 0.12), 0 2px 10px rgba(16, 47, 67, 0.12);
        background: ${color.emphasis.NEUTRAL_N0};
    }
`;

export const UrgentDot = styled.span`
    width: 8px;
    height: 8px;
    border-radius: 999px;
    background: ${color.status.WARNING};
    display: inline-block;
`;

export const UrgentText = styled.span`
    font-size: 14px;
    font-weight: 700;
    color: ${color.status.WARNING};
`;

export const MetaDividerV = styled.span`
    width: 1px;
    height: 16px;
    background: ${color.secondary.BORDER};
    display: inline-block;
`;

export const MetaItem = styled.div`
    display: inline-flex;
    align-items: center;
    gap: 8px;
`;

export const MetaLabel = styled.span`
    font-size: 12px;
    color: ${color.secondary.DARK_GREY};
    text-transform: uppercase;
    letter-spacing: 0.02em;
`;

export const MetaValue = styled.span`
    font-size: 15px;
    font-weight: 600;
    color: ${color.secondary.CHARCOAL};
`;

export const IconWrap = styled.span`
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 16px;
    height: 16px;
    & > svg {
        width: 16px;
        height: 16px;
        display: block;
    }
`;
